/**Список разрешений пользователя */
enum EmployeeQueueAccessEnum {
  /**Могут видеть чужие задачи */
  VisibilityOtherTask = 0,
  /**Могут добавлять задачи */
  CreateTask = 1,
  /**Могут редактировать чужие задачи  */
  UpdateOtherTask = 2,
}
export { EmployeeQueueAccessEnum };
